<template>
  <admin-wrapper title-translation-path="admin.LOCATION_LAB" :module-enabler="moduleEnabler" :has-buttons="false" />
</template>
<script>
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'LocationLabSettings',
  components: { AdminWrapper },
  computed: {
    moduleEnabler() {
      return {
        name: 'location_lab_module_enabled',
        translationPath: 'admin.LOCATION_LAB',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.LOCATION_LAB') }),
      };
    },
  },
};
</script>
